import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import PortalSectionHeader from '@/components/portalSection/portal-section-header.vue';
import { useRepositories } from '@/plugins/repositories';
import RecentlyAddedDocumentCarousel from './recently-added-document-carousel.vue';
export default defineComponent({
  components: {
    PortalSectionHeader: PortalSectionHeader,
    RecentlyAddedDocumentCarousel: RecentlyAddedDocumentCarousel
  },
  props: {
    disablePersonalFeature: {
      type: Boolean,
      requred: false,
      default: false
    }
  },
  setup: function setup() {
    var loadingRecents = ref(true);
    var recents = ref([]);
    var $repositories = useRepositories();
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return $repositories.docs.recentlyAdded(10);
          case 2:
            recents.value = _context.sent;
            loadingRecents.value = false;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return {
      recents: recents,
      loadingRecents: loadingRecents
    };
  }
});